import { render, staticRenderFns } from "./FloatingActionBar.vue?vue&type=template&id=21107890&scoped=true"
import script from "./FloatingActionBar.vue?vue&type=script&lang=js"
export * from "./FloatingActionBar.vue?vue&type=script&lang=js"
import style0 from "./FloatingActionBar.vue?vue&type=style&index=0&id=21107890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21107890",
  null
  
)

export default component.exports